export default __webpack_public_path__ + "static/media/background.4b35e888.jpg";